<template>
	<div class="bg-white px-3 index" style="margin: 0 26px;margin-bottom: 0!important;">
		<div class="add_tits" ref="titles">
			<el-form class="form-inlines " :inline="true">
				<div>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
				<el-table-column prop="id" label="编号"></el-table-column>
				<el-table-column prop="team_name" label="团队名称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
				<el-table-column prop="create_time" label="申请开启群聊" show-overflow-tooltip>
					<template slot-scope="scope">
						<span :class="{color_red:scope.row.teamChatStatus!=0}">{{scope.row.teamChatStatusText}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-document"
							@click="handleEdit(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="工作室详情" :visible.sync="dialogVisible" center top="20px" width="40%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<div class="tdmc">{{objxx.team_name}}</div>
					</div>
					<div class="u-f tdxx">
						<img :src="objxx.head_portrait_pic[0].url" v-if="objxx.head_portrait_pic" class="image" />
						<div class="tdjs">
							<div class="">{{objxx.real_name}} {{objxx.hospital_id}} {{objxx.department_id}}
								{{objxx.competent_id}}</div>
							<div>{{objxx.good_at}} {{objxx.introduction}}</div>
						</div>
					</div>
					<div class="tdxqed u-f u-wrap">
						<div v-for="item in objxx.TeamTeamMember" :key="item.id">
							<img :src="item.head_portrait_pic[0].url" alt="" class="tdimg">
							<div>{{item.real_name}}</div>
						</div>
					</div>
					<div v-if="objxx.teamChatStatus==3">
						<span>是否同意开启群聊</span>
						<el-radio-group v-model="isqunradio">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="2">否</el-radio>
						</el-radio-group>
					</div>
				</el-card>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
				<el-button v-if="objxx.teamChatStatus==3" type="primary" @click="handleexam" size="small">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>


<script>
	import {
		mapState
	} from 'vuex'
	import tinymce from '@/components/common/tinymce.vue';
	import comment from '@/components/header/comment.vue';
	export default {
		components: {
			tinymce,
			comment
		},
		data() {
			return {
				lb_options: [],
				loading: false,
				tableData: [],
				count: 0,
				currentPage: 1,
				pagesize: 15,
				height: null,
				// 
				eid: '',
				dialogVisible: false,
				objxx: '',
				isqunradio: 1,
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getHeight()
			that.begin()
		},
		methods: {
			getHeight() {
				let that = this
				var titles = that.$refs.titles.offsetHeight
				that.height = window.innerHeight - titles - 200 + 'px'
				window.onresize = () => {
					var titles = that.$refs.titles.offsetHeight
					that.height = window.innerHeight - titles - 200 + 'px'
				}
			},
			// 搜索
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 15
				that.search()
			},
			search() {
				let that = this
				that.tableData = []
				that.loading = true
				axios.post("/admin/pc/teamList", {
						page: that.currentPage,
						page_count: that.pagesize,
					}, {
						token: true
					})
					.then(response => {
						that.loading = false
						that.tableData = response.data.data.list
						that.count = response.data.data.count
					})
					.catch(error => {})
			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			// 编辑
			handleEdit(row, index) {
				let that = this
				that.dialogVisible = true
				that.eid = row.id
				that.getxx()
			},
			handleexam() {
				axios.post("/admin/pc/DoctorTeam/examine", {
						id: this.eid,
						examine:this.isqunradio
					}, {
						token: true
					})
					.then(response => {
						if (response.data.code==200) {
							this.dialogVisible = false
							this.search()
						}
					})
					.catch(error => {})
			},
			getxx() {
				axios.post("/admin/pc/doctorTeamRead", {
						id: this.eid
					}, {
						token: true
					})
					.then(response => {
						this.objxx = response.data.data
					})
					.catch(error => {})
			}
		},
	};
</script>


<style scoped>
 .index{
        border-radius: 6px;
        padding-bottom: 10px;
    }
	.tdmc {
		font-weight: bold;
		font-size: 20px;
	}

	.image {
		width: 100px !important;
		height: 100px !important;
		border-radius: 10px !important;
	}

	.tdimg {
		width: 50px !important;
		height: 50px !important;
		border-radius: 50% !important;
	}

	.tdxqed {
		padding: 10px;
	}

	.tdxx {
		padding: 10px;
	}

	.tdjs {
		padding: 10px;
	}

	.color_red {
		color: red;
	}
</style>